import React, { useState, useEffect } from 'react';
import { Shield, AlertTriangle, BarChart3, Users, Server, X } from 'lucide-react';
import DashboardTab from './DashboardTab';
import BloqueosTab from './BloqueosTab';
import TrustedIPsTab from './TrustedIPsTab';
import { seguridadAPI } from './api';

const AdminSeguridad = () => {
  const [tab, setTab] = useState('dashboard');
  const [bannerEvents, setBannerEvents] = useState([]);
  const [dismissed, setDismissed] = useState(false);

  // Detectar eventos críticos activos para el banner rojo
  useEffect(() => {
    const load = () => {
      seguridadAPI
        .dashboard('24h')
        .then((r) => {
          const spraying = (r.data?.spraying || []).filter(
            (e) => !e.acknowledged && (e.severity === 'block_short' || e.severity === 'block_long')
          );
          setBannerEvents(spraying);
        })
        .catch(() => {});
    };
    load();
    const iv = setInterval(load, 60000);
    return () => clearInterval(iv);
  }, [tab]);

  const tabs = [
    { key: 'dashboard', label: 'Dashboard', icon: BarChart3 },
    { key: 'bloqueos', label: 'Bloqueos activos', icon: Users },
    { key: 'ips', label: 'IPs de confianza', icon: Server },
  ];

  return (
    <div className="space-y-6" data-testid="admin-seguridad-page">
      {/* Header */}
      <div className="flex items-start gap-3">
        <div className="p-2 bg-[#fbf7f0] rounded-lg border border-[#e8dfd0]">
          <Shield size={22} className="text-[#9d8272]" />
        </div>
        <div className="flex-1">
          <h1
            className="text-2xl sm:text-4xl font-bold text-[#2D2D2D]"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Seguridad
          </h1>
          <p className="text-sm text-[#5A5A5A] mt-1">
            Panel de control de rate limiting, bloqueos de login y IPs de confianza.
          </p>
        </div>
      </div>

      {/* Banner de eventos críticos de spraying */}
      {bannerEvents.length > 0 && !dismissed && (
        <div
          className="flex items-start gap-3 bg-red-50 border border-red-300 rounded-lg px-4 py-3"
          data-testid="banner-spraying"
        >
          <AlertTriangle size={20} className="text-red-600 mt-0.5 shrink-0" />
          <div className="flex-1">
            <div className="font-semibold text-red-900 text-sm">
              Actividad sospechosa detectada
            </div>
            <div className="text-xs text-red-800 mt-1">
              {bannerEvents.length} evento(s) de password spraying activo(s) sin
              reconocer. Revísalos en la sección "Bloqueos activos" o en la línea de
              tiempo del Dashboard.
            </div>
          </div>
          <button
            onClick={() => setDismissed(true)}
            className="text-red-600 hover:text-red-800"
            data-testid="banner-dismiss"
            aria-label="Cerrar banner"
          >
            <X size={16} />
          </button>
        </div>
      )}

      {/* Tabs */}
      <div className="border-b border-[#E8E8E7] flex gap-1">
        {tabs.map((t) => {
          const Icon = t.icon;
          const active = tab === t.key;
          return (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className={`px-4 py-2.5 text-sm font-medium flex items-center gap-2 border-b-2 transition ${
                active
                  ? 'border-[#9d8272] text-[#2D2D2D]'
                  : 'border-transparent text-[#5A5A5A] hover:text-[#2D2D2D]'
              }`}
              data-testid={`tab-${t.key}`}
            >
              <Icon size={14} />
              {t.label}
            </button>
          );
        })}
      </div>

      {/* Tab content */}
      <div>
        {tab === 'dashboard' && <DashboardTab />}
        {tab === 'bloqueos' && <BloqueosTab />}
        {tab === 'ips' && <TrustedIPsTab />}
      </div>
    </div>
  );
};

export default AdminSeguridad;
